module.exports = __webpack_public_path__ + "img/casepic3.8e5ee66f.png";